import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import React from "react";
import { ArtistSidePanel } from "../Company/CompanySidePanel";
import ShowDateTime from "show/components/ShowDateTime";
import AppointmentPhase from "components/Atoms/AppointmentPhase";

interface ExternalEventSidePanelDetailsProps {
  externalEvent: server.dto.ExternalEventPreview
}

export const ExternalEventSidePanelDetails = (props: ExternalEventSidePanelDetailsProps) => {
  const { externalEvent, calendar } = props.externalEvent;

  return <SidePanelDetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    fields={[{
      key: "artist",
      label: site.currentEnvironment.functionGroups.artist.singular,
      isEmpty: !externalEvent.artist,
      render: () => <ArtistSidePanel
        companyId={externalEvent.artist.artistId}
        trigger={<a>{externalEvent.artist.name}</a>}
        fallbackIfNoPermission={<>{externalEvent.artist.name}</>}
      />
    }, {
      key: "dateTime",
      label: RESX.DateTime.lblDate,
      render: () => <ShowDateTime dateTime={externalEvent.dateTime} />
    }, {
      key: "summary",
      label: RESX.GeneralLabels.Title,
      isEmpty: !externalEvent.summary,
      render: () => <span>{externalEvent.summary}</span>
    }, {
      key: "status",
      label: RESX.Status.resxStatus,
      render: () => <AppointmentPhase value={externalEvent.phase} displayLabel />
    }, {
      key: "calendar",
      label: RESX.DateTime.Calendar,
      render: () => <span>{calendar.title}</span>
    }, {
      key: "description",
      label: RESX.GeneralLabels.Description,
      isEmpty: !externalEvent.content,
      render: () => <span style={{ whiteSpace: "pre-wrap" }}>{externalEvent.content}</span>
    }]}
  />
}